import freeGlobal from './_freeGlobal.js';

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

export default root;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash-es/_root.js
// module id = 91
// module chunks = 0


// WEBPACK FOOTER //
// node_modules/lodash-es/_root.js